module.exports = __webpack_public_path__ + "static/media/Imagen 9.3792003f.jpg";